export default {"src":"/_next/static/media/2-h.46298cec.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};